module.exports = __webpack_public_path__ + "static/img/050江城易检.5696816.png";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/050江城易检.png
// module id = z1th
// module chunks = 0